import React, {createContext, useContext, useState} from "react";

interface ScrollContextType {
    scrollToSearch: boolean;
    setScrollToSearch: (state: boolean) => void;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollProvider = ({children}: { children: React.ReactNode }) => {
    const [scrollToSearch, setScrollToSearch] = useState<boolean>(false);

    return (
        <ScrollContext.Provider value = {{scrollToSearch, setScrollToSearch}} >
            {children}
        </ScrollContext.Provider >
    );
};

export const useScrollContext = () => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error("useScrollContext must be used within a ScrollProvider");
    }
    return context;
};
